import { Type } from 'class-transformer';
import {
  IsBoolean,
  IsDate,
  IsIn,
  IsNotEmpty,
  IsOptional,
  IsString,
  ValidateNested,
} from 'class-validator';
import type { QrTargetType } from './qr-target-type.enum';

export class LotPreviewDto {
  @IsString()
  @IsNotEmpty()
  id!: string;

  @IsString()
  @IsNotEmpty()
  name!: string;

  @IsString()
  @IsNotEmpty()
  lotNumber!: string;

  @IsString()
  @IsOptional()
  recipeName!: string | null;

  @IsDate()
  @IsOptional()
  expiryDate!: Date | null;

  @IsBoolean()
  hasNoExpiry!: boolean;

  @IsIn(['ACTIVE', 'EXHAUSTED', 'EXPIRED', 'BLOCKED'])
  status!: 'ACTIVE' | 'EXHAUSTED' | 'EXPIRED' | 'BLOCKED';

  @IsDate()
  @IsOptional()
  exhaustedAt!: Date | null;
}

export class ResolveQrResponseDto {
  kind!: QrTargetType;
  targetId!: string;
  displayName!: string;
  /// Frontend route to navigate to after a successful resolve.
  redirectPath!: string;

  @ValidateNested()
  @Type(() => LotPreviewDto)
  @IsOptional()
  lotPreview?: LotPreviewDto;
}

export class QrBindingByTargetResponseDto {
  qrUuid!: string | null;
}
